<template>
    <div class="PublicMobileMenu">
        <a href="#" class="PublicMobileMenu__toggle" @click.self.prevent="toggleMenu"></a>
        <div class="PublicMobileMenu__menu" v-show="show">
            <div class="PublicMobileMenu__menu-toggle-container">
                <a href="#" class="PublicMobileMenu__toggle" @click.self.prevent="toggleMenu"></a>
            </div>
            <a :class="pagesClasses" @click.prevent="toggleSections">Pages</a>
            <ul class="PublicMobileMenu__sections" v-show="showSections">
                <li v-for="section in sections">
                    <a :href="section.url" class="PublicMobileMenu__section">{{ section.name }}</a>
                </li>
            </ul>

            <div class="PublicMobileMenu__current-section">Stats</div>
            <ul class="PublicMobileMenu__pages">
                <li v-for="page in pages">
                    <a :href="page.url" class="PublicMobileMenu__page">{{ page.name }}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
                showSections: false,

                sections: [
                    { name: 'Home', url: 'http://beepbeep.ie' },
                    { name: 'Cars', url: 'http://beepbeep.ie/used-cars/search.html' },
                    { name: 'Vans', url: 'http://beepbeep.ie/used-vans/search.html?SV(F5427)=289432' },
                    { name: 'Reviews', url: 'http://beepbeep.ie/news-section/Reviews.html' },
                    { name: 'News', url: 'http://beepbeep.ie/news-section/News.html' },
                    { name: 'Features', url: 'http://beepbeep.ie/news-section/Features.html' },
                    { name: 'Blog', url: 'http://beepbeep.ie/news-section/Blog.html' },
                    { name: 'Value My Car', url: 'http://beepbeep.ie/valuation.html' },
                    { name: 'Approved Programs', url: 'http://beepbeep.ie/approved-programs' },
                    { name: 'Dealers', url: 'http://beepbeep.ie/dealers' },
                    { name: 'CO2 & Price Guide', url: 'http://beepbeep.ie/price-guide' },
                ],

                pages: [
                    { name: 'Passenger Cars', url: '/' },
                    { name: 'Light Commercials', url: '/light-commercial-vehicles' },
                    { name: 'Heavy Commercials', url: '/heavy-commercial-vehicles' },
                    { name: 'Member Login', url: 'https://members.simi.ie/login' },
                ]
            }
        },

        computed: {
            pagesClasses() {
                return {
                    'PublicMobileMenu__sections-heading': true,
                    'PublicMobileMenu__sections-heading--open': this.showSections,
                }
            }
        },

        methods: {
            toggleSections() {
                this.showSections = ! this.showSections;
            },

            toggleMenu() {
                if (this.show) {
                    this.show = false;
                    document.querySelector('body').classList.remove('Utility--no-scroll');
                } else {
                    this.show = true;
                    document.querySelector('body').classList.add('Utility--no-scroll');
                    bus.$emit('hide-cover-alls', 'mobile-menu');
                }
            }
        }
    }
</script>